export default __webpack_public_path__ + "static/media/place_outline_20.2b7623d7.svg";